import { render, staticRenderFns } from "./ClientDetailsActivity.vue?vue&type=template&id=a787233a&scoped=true&"
import script from "./ClientDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=a787233a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a787233a",
  null
  
)

export default component.exports